import { memo, useCallback } from 'react';

import { type Board } from '@air/api/types';

import { PrivateCopyrightSelect } from '~/components/Filters/CopyrightFilter/components/PrivateCopyrightSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard } from '~/components/Filters/StringArrayFilterCard';
import { type BaseStringSelectProps } from '~/components/StringSelect';

export type PrivateCopyrightFilterCardProps = {
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateCopyrightFilterCard = memo(({ boardId, libraryId, ...props }: PrivateCopyrightFilterCardProps) => {
  const renderCopyrightSelect = useCallback(
    (props: BaseStringSelectProps) => <PrivateCopyrightSelect {...props} boardId={boardId} libraryId={libraryId} />,
    [boardId, libraryId],
  );

  return (
    <StringArrayFilterCard
      filter="copyrights"
      filterCardType="copyright"
      StringSelect={renderCopyrightSelect}
      {...props}
    />
  );
});

PrivateCopyrightFilterCard.displayName = 'PrivateCopyrightFilterCard';
